import { ChangeDetectionStrategy, Component, inject, InjectionToken, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AccessibleClickDirective } from '../../../directives';

export type HelpfullLink = Record<'label' | 'url', string>;
export const INFO_PAGE_HELPFULL_LINKS = new InjectionToken<HelpfullLink[]>('INFO_PAGE_HELPFULL_LINKS');

@Component({
  selector: 'lib-info-page-helpfull-links',
  imports: [MatIconModule, AccessibleClickDirective],
  templateUrl: './info-page-helpfull-links.component.html',
  styleUrl: './info-page-helpfull-links.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoPageHelpfullLinksComponent {
  title = input<string>();
  links = input<HelpfullLink[]>([]);

  router = inject(Router);

  navigateTo(path: HelpfullLink['url']) {
    this.router.navigate([path]);
  }
}
